import { accordionDetailsClasses, accordionSummaryClasses } from '@mui/material';

const muiAccordionOverride = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      padding: 0,
      borderRadius: theme?.components?.accordion?.borderRadius,
      overflow: 'hidden',

      [`& .${accordionSummaryClasses.root}`]: {
        padding: theme?.components?.accordion?.header?.padding?.sm,
        minHeight: theme?.components?.accordion?.header?.minHeight?.sm,
        backgroundColor: theme?.palette?.background?.accordion?.header,
        transition: 'border-radius 0.2s ease',

        [`&:focus`]: {
          backgroundColor: theme?.palette?.background?.accordion?.header,
        },
      },

      // [`&.Mui-expanded .${accordionSummaryClasses.root}`]: {},

      [`& .${accordionSummaryClasses.content}`]: {
        margin: 0,
      },

      [`& .${accordionDetailsClasses.root}`]: {
        margin: 0,
        padding: 0,
        backgroundColor: theme?.palette?.background?.accordion?.body,
      },
    }),
  },
  variants: [],
};
export default muiAccordionOverride;
